<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Admin Two Approval</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <b-spinner class="center-spinner" v-if="!loaded" variant="primary" label="Spinning"></b-spinner>
                        <b-table v-if="loaded" striped hover :items="response" show-empty="true" empty-text='There are no records to show'
                                 :fields="['Selected','SubmittedDate','SubmitterName','Approvals','ReportName','Project','Type','Status','ReimbursementTotal']">
                            <template v-slot:head(Selected)="data">
                                <b-button size="sm" @click="selectAll()" class="mr-2">
                                    Select All
                                </b-button>
                            </template>
                            <template v-slot:cell(Selected)="data">
                                <b-form-checkbox v-model="data.value"
                                                 value="true">
                                </b-form-checkbox>
                            </template>
                            <template v-slot:cell(ReportName)="data">
                                <span v-html="data.value"></span>
                            </template>
                            <template v-slot:cell(SubmittedDate)="data">
                                {{data.value | formatDate}}
                            </template>
                            <template v-slot:cell(ReimbursementTotal)="data">
                                {{data.value | currency}}
                            </template>
                        </b-table>
                        <b-button v-if="loaded" size="sm" @click="approveSelected()" class="mr-2">
                            Approve Selected
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReportService from '@/services/ReportService'
    import ApprovalService from '@/services/ApprovalService'

    export default {
        async created() {
            this.response = await ReportService.getAdminTwoApprovals();
            this.loaded = true;
        },
        data() {
            return {
                response: null,
                isSelectAll: false,
                loaded: false
            }
        },
        methods: {
            selectAll() {
                if (this.isSelectAll) {
                    this.response.forEach(element => element.Selected = false);
                    this.isSelectAll = false;
                }
                else {
                    this.response.forEach(element => element.Selected = true);
                    this.isSelectAll = true;
                }
            },
            async approveSelected() {
                for await (const item of this.response) {
                    if (item.Selected) {
                        try {
                            await ApprovalService.submitApproval(item.ExpenseReportID);
                            this.$notify({ group: 'success', type: 'success ', title: 'Success', text: "Approval request sent successfully." });
                        } catch (e) {
                            this.$notify({ group: 'errors', type: 'error', title: 'Error', text: e });
                        }
                    }
                }

                this.response = await ReportService.getAdminTwoApprovals();
            }
        }
    }
</script>